import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";

import constants from '../../../constants';
import MoveTypeDropDown from "../../../uiControls/MoveTypeDropDown";
import {Search} from "../../../filtering";

import {NavigationType, openNewPage} from '../../../util/navigationHelpers';

import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';

import {
  DateRenderer,DateTimeRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {OeMblListItem, OemListType} from "../../../fms.data/models/OeMblListItem";
import {oceanExportMblList} from "../tableSettings";
import IfmsModal from "../../../ui/IfmsModal";
import fastStorage from "../../../fastStorage";
import MblMilestonePopup from "./MblMilestonePopup";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import loadInfoAreaInvoiceBillCrDb from '../../common/InfoAreaInvoiceBillCrDb';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, changeRQEvent, LastEventRenderer, LclFclFilterRenderer, LclFclRenderer, RecognizedFilterRenderer, RecognizedRenderer, RQFilterEventRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer, TrackEventNameRenderer } from '../../common/commonListRenderers';
import postal from 'postal';
import { getFmsGlobal } from '../../../globals';
import { FmsSecTask } from '../../../fms.core/constants';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import _ from 'lodash';
import RecogModal from '../../../ui/RecogModal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import { formatShipmentType, formatLclFcl } from '../../common/utils/formatUtils';
import { OeHblListItem } from '../../../fms.data/models/OeHblListItem';
import { SecType } from '../../../fms.enum';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton, { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import TrackingRequest from '../../reports/TrackingRequest';
import TrackingRQIcon2 from '../../../img/toolbar-trackingrq-light.svg';
import TrackingRQIcon2_D from '../../../img/toolbar-trackingrq-dark.svg';
import TrackingRQIcon3 from '../../../img/cntr-tracking-rq-light.svg';
import TrackingRQIcon3_D from '../../../img/cntr-tracking-rq-dark.svg';
import useListTrackingRequest, { getTrackRequestTitle } from '../../../hooks/useListTrackingRequest';
import { displayLastTrackingEvent } from '../../common/commonExportFormat';
import taskReminderIconRed from '../../../img/pin_red.svg';
import cntrBlue from '../../../img/cntr-tracking-rq-12-blue.svg';
import { OeHbl } from '../../../fms.core/OeHbl';
import cntrGreen from '../../../img/cntr-tracking-rq-12-green.svg';

function MoveTypeFilterRenderer({value, onChange}: any) {
  return (
    <MoveTypeDropDown
      name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}      
    />
  );
}

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="Container Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}


function HblRenderer({data, row, value}: any) {
  const {switchToHblFor} = useMblOperations();

  if (data[row.index].direct) {
    return <div className="ifms-table-default">DBL</div>;
  }

  if (value === '0') {
    return <div className="ifms-table-default">{value}</div>;
  }

  const isNumber = !isNaN(parseInt(value));
  if (!isNumber) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToHblFor(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useMblOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em', textDecoration: 'underline' }}>{value}</PrimaryInverseButton>
}

function ContainerRenderer({ cell, value, data, row }: any) {
  const l = data[row.index];
  return (
    <div className="ifms-table-default" id={`oem-container-${cell.column.id}`} data-tooltip={l.fullContainerNo}>{value}</div>
  );
}

function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useMblOperations();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div className="ifms-table-default" onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}{isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}}width='11px' height='11px' src={taskReminderIconRed} />: <></>}
    </div>
}



// function CntrNoRenderer({value}: any) {
//   return <span className="input-control-row-label-link">{value}</span>
// }

function useMblOperations() {
  const history = useHistory();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  function openDocServer(mbl:OeMblListItem|null){
    if (!mbl) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }


  function switchToHblFor(mbl: OeMblListItem | null) {
    const hblSec = findSecurityTask(appContext, FmsSecTask.OEHbl);
    if (!mbl || !hblSec.grantRead) {
      return;
    }

    // jobListContext.setFilterForScreenExternally('/common/joblistview/oeHbl/oceanExport', 'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false);
    jobListContext.setFilterForScreenExternally('/common/joblistview/oeHbl/oceanExport', 
    'oeMblId', 'Ref. #', mbl.id, 'u2Date', false, true, null, 'refNo', mbl.refNo, false,true);
    openNewPage(history, `/common/joblistview/oeHbl/oceanExport`, NavigationType.newPage);
  }
  
  async function switchToAcctInfo(mbl:OeMblListItem|null) {
    if (!mbl) {
      return;
    }
    
    if (mbl.hblCount === 'SBL' && mbl.hblId > 0) // Single BL
      openNewPage(history, `/accounting/Acct/${JobNames.OEHbl}/${mbl.hblId}`, NavigationType.newPage);
    else
      openNewPage(history, `/accounting/Acct/${JobNames.OEMbl}/${mbl.id}`, NavigationType.newPage);
  }


  return {switchToHblFor, switchToAcctInfo, openDocServer};
}

function useSelectedMblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  const {switchToHblFor, openDocServer} = useMblOperations();

  const selectedElement = jobListContext.selectedElement as OeMblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');

  const setSavedEntityOeh = useSetEditedId([JobNames.OEHbl]);

  const { trackRequestFunc } = useListTrackingRequest({
    jobName: JobNames.OEMbl,
    getMblNo: () => selectedElement?.mblNo ?? '',
    getContainerNo: () => selectedElement?.containerNo ?? '',
    getTrType: () => selectedElement?.trType ?? '',
    getTrStatus: () => selectedElement?.trStatus ?? '',
    getJobId: () => selectedElement?.id ?? 0,
  });

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/mbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/oceanExport/mbl/add', NavigationType.newPage);
  }

  async function deleteMbl() {
    if (!selectedElement) {
      return;
    }

    if (selectedElement.hblCount !== 'DBL' && selectedElement.hblCount !== 'SBL' && selectedElement.hblCount !== '0') {
      await showGlobalOkDialog('Need to delete HBL first.',false,null,'warning');
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close MBL first', false, null, "warning");
    //   return;
    // }

    
    if (selectedElement.hblCount === 'SBL' && selectedElement.hblId > 0) {
      // Single BL
      if (
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OEHB/${selectedElement.hblId}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OEHB/${selectedElement.hblId}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OEHB/${selectedElement.hblId}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OEHB/${selectedElement.hblId}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OEHB/${selectedElement.hblId}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OEHB/${selectedElement.hblId}`)
      ) {
        await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first',false,null,'warning');
        return;
      }
    }
    else {
      if (
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OEMB/${selectedElement.id}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OEMB/${selectedElement.id}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OEMB/${selectedElement.id}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OEMB/${selectedElement.id}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OEMB/${selectedElement.id}`) ||
        jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OEMB/${selectedElement.id}`)
      ) {
        await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.',false,null,'warning');
        return;
      }
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OEMbl, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        if (selectedElement.hblCount === 'SBL' && selectedElement.hblId > 0) {
          // Single BL
          const editUrl = `/oceanExport/hbl/edit/${selectedElement.hblId}`;
          const viewUrl = `/oceanExport/hbl/view/${selectedElement.hblId}`;
          if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
              context.resetForCurrentJob();
              removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
          }
          setSavedEntityOeh(selectedElement.hblId?.toString(), false, true);
        }
        else {
          const editUrl = `/oceanExport/mbl/edit/${selectedElement.id}`;
          const viewUrl = `/oceanExport/mbl/view/${selectedElement.id}`;
          if ( jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
              context.resetForCurrentJob();
              removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
          }
        }
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    var id = selectedElement.id;
    var editUrl =`/oceanExport/mbl/edit/${id}`;
    var viewUrl = `/oceanExport/mbl/view/${id}`;

    // Single BL
    if (selectedElement.hblCount === 'SBL' && selectedElement.hblId > 0) {
      id = selectedElement.hblId;
      editUrl =`/oceanExport/hbl/edit/${id}`;
      viewUrl = `/oceanExport/hbl/view/${id}`;
    } 
    
    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/oceanExport/mbl/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    var id = selectedElement.id;
    let jobName = JobNames.OEMbl;
    let tabIndex = 2;
    let baseUrl = '/oceanExport/mbl';
    let editBaseUrl = `${baseUrl}/edit/${id}`;
    let viewBaseUrl = `${baseUrl}/view/${id}`;

    // Single BL
    if (selectedElement.hblCount === 'SBL' && selectedElement.hblId > 0) {
      id = selectedElement.hblId;
      jobName = JobNames.OEHbl;
      tabIndex = 3;
      baseUrl = '/oceanExport/hbl';
      editBaseUrl = `${baseUrl}/edit/${id}`;
      viewBaseUrl = `${baseUrl}/view/${id}`;
    } 

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${jobName}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    var id = selectedElement.id;
    let jobName = JobNames.OEMbl;
    let tabIndex = 3;
    let baseUrl = '/oceanExport/mbl';
    let editBaseUrl = `${baseUrl}/edit/${id}`;
    let viewBaseUrl = `${baseUrl}/view/${id}`;

    // Single BL
    if (selectedElement.hblCount === 'SBL' && selectedElement.hblId > 0) {
      id = selectedElement.hblId;
      jobName = JobNames.OEHbl;
      tabIndex = 5;
      baseUrl = '/oceanExport/hbl';
      editBaseUrl = `${baseUrl}/edit/${id}`;
      viewBaseUrl = `${baseUrl}/view/${id}`;
    } 

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${jobName}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  async function moveToDeleteHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.OEDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OEMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.OERecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/recogHistory?jobname=${JobNames.OEMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    var id = selectedElement.id;
    var editUrl =`/oceanExport/mbl/edit/${id}`;
    var viewUrl = `/oceanExport/mbl/view/${id}`;
    var listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEMbl, selectedElement.branch);

    // Single BL
    if (selectedElement.hblCount === 'SBL' && selectedElement.hblId > 0) {
      id = selectedElement.hblId;
      editUrl = `/oceanExport/hbl/edit/${id}`;
      viewUrl = `/oceanExport/hbl/view/${id}`;
      listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement.branch);
    } 

    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/mbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/oceanExport/mbl/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToHbl() {
    const selectedElement = jobListContext.selectedElement as OeMblListItem;
    if (selectedElement?.hblCount !== 'DBL') switchToHblFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return {create, deleteMbl, edit, view, copy, switchToHbl, recognize, viewBillings, moveToDeleteHistoryReport, moveToRecogHistoryReport, viewProfit, trackRequestFunc};
}

function useSelectedHblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const selectedElement = jobListContext.selectedElement as OeHblListItem;
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const setSavedEntityOem = useSetEditedId([JobNames.OEMbl]);

  async function createHbl() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/add?mblRefId=${selectedElement.id}`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const newUrl = `/oceanExport/hbl/add?mblRefId=${selectedElement.id}`;

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  return { createHbl, setSavedEntityOem };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteMbl, edit, view, copy, switchToHbl, recognize, viewBillings, viewProfit, trackRequestFunc } = useSelectedMblOperations();
  const { createHbl } = useSelectedHblOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as any;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const setSavedEntityAfterClose = useSetEditedId([JobNames.OEHbl, JobNames.OEBook]);
  const userID = appContext.user ? appContext.user.id ?? '' : '';

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEMbl, selectedElement?.branch);
  const listSec_H = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement?.branch); // MBL이 SBL일 때의 HBL 권한
  const listSec_H2 = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement?.branch, true);
  const fmsGlobal = getFmsGlobal();

  function openContainerStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OEMbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

    // Single BL
    if (selectedElement.hblCount === 'SBL' && selectedElement.hblId > 0) {
      const hasOpened =
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/edit/${selectedElement.hblId}`) ||
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/view/${selectedElement.hblId}`)

      if (selectedElement.isClosed && hasOpened) {
        const editModelKey = `editOeHbl${selectedElement.hblId}-/oceanExport/hbl/edit`;
        const viewModelKey = `viewOeHbl${selectedElement.hblId}-/oceanExport/hbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 0;
          fastStorage[keyMatch].isFileClosed = false;
          fastStorage[keyMatch].closedBy = '';
          fastStorage[keyMatch].closeDate = null;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 0;
          fastStorage[viewKeyMatch].isFileClosed = false;
          fastStorage[viewKeyMatch].closedBy = '';
          fastStorage[viewKeyMatch].closeDate = null;
        }
      }else if (!selectedElement.isClosed && hasOpened) {
        const editModelKey = `editOeHbl${selectedElement.hblId}-/oceanExport/hbl/edit`;
        const viewModelKey = `viewOeHbl${selectedElement.hblId}-/oceanExport/hbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        const closeDate = await appContext.api.getFieldValueDate({
          id: selectedElement.hblId,
          tableName: 'T_OOHMAIN',
          fieldName: 'F_CloseDate'
        });

        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 1;
          fastStorage[keyMatch].isClosed = true;
          fastStorage[keyMatch].closedBy = userID;
          fastStorage[keyMatch].closeDate = closeDate;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 1;
          fastStorage[viewKeyMatch].isClosed = true;
          fastStorage[viewKeyMatch].closedBy = userID;
          fastStorage[viewKeyMatch].closeDate = closeDate;
        }
      }
    }
    else {
      const hasOpened =
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/edit/${selectedElement.id}`) ||
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/view/${selectedElement.id}`)

      if (selectedElement.isClosed && hasOpened) {
        const editModelKey = `editOeMbl${selectedElement.id}-/oceanExport/mbl/edit`;
        const viewModelKey = `viewOeMbl${selectedElement.id}-/oceanExport/mbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 0;
          fastStorage[keyMatch].isFileClosed = false;
          fastStorage[keyMatch].closedBy = '';
          fastStorage[keyMatch].closeDate = null;

          if (fastStorage[keyMatch].hblList) {
            fastStorage[keyMatch].hblList.forEach((hbl: OeHbl) => {
              hbl.fileClosed = 0;
            });
          }

        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 0;
          fastStorage[viewKeyMatch].isFileClosed = false;
          fastStorage[viewKeyMatch].closedBy = '';
          fastStorage[viewKeyMatch].closeDate = null;

          if (fastStorage[viewKeyMatch].hblList) {
            fastStorage[viewKeyMatch].hblList.forEach((hbl: OeHbl) => {
              hbl.fileClosed = 0;
            });
          }
        }
      } else if (!selectedElement.isClosed && hasOpened) {
        const editModelKey = `editOeMbl${selectedElement.id}-/oceanExport/mbl/edit`;
        const viewModelKey = `viewOeMbl${selectedElement.id}-/oceanExport/mbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        const closeDate = await appContext.api.getFieldValueDate({
          id: selectedElement.id,
          tableName: 'T_OOMMAIN',
          fieldName: 'F_CloseDate'
        });

        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 1;
          fastStorage[keyMatch].isClosed = true;
          fastStorage[keyMatch].closedBy = userID;
          fastStorage[keyMatch].closeDate = closeDate;
          if (fastStorage[keyMatch].hblList) {
            fastStorage[keyMatch].hblList.forEach((hbl: OeHbl) => {
              hbl.fileClosed = 1;
            });
          }
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 1;
          fastStorage[viewKeyMatch].isClosed = true;
          fastStorage[viewKeyMatch].closedBy = userID;
          fastStorage[viewKeyMatch].closeDate = closeDate;
          if (fastStorage[viewKeyMatch].hblList) {
            fastStorage[viewKeyMatch].hblList.forEach((hbl: OeHbl) => {
              hbl.fileClosed = 1;
            });
          }
        }
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  async function processAccountLock() {
    const accountLockResult = await appContext.api.accountClose(JobNames.OEMbl, selectedElement.id, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult,false,null,'warning');
      return;
    }

    // Single BL
    if (selectedElement.hblCount === 'SBL' && selectedElement.hblId > 0) {
      const hasOpened =
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/edit/${selectedElement.hblId}`) ||
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/view/${selectedElement.hblId}`)

      if (selectedElement.isAccountClosed && hasOpened) {
        const editModelKey = `editOeHbl${selectedElement.hblId}-/oceanExport/hbl/edit`;
        const viewModelKey = `viewOeHbl${selectedElement.hblId}-/oceanExport/hbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));


        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 0;
          fastStorage[keyMatch].isAccountClosed = false;
          fastStorage[keyMatch].accountClosedBy = '';
          fastStorage[keyMatch].accountCloseDate = null;
        }if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 0;
          fastStorage[viewKeyMatch].isAccountClosed = false;
          fastStorage[viewKeyMatch].accountClosedBy = '';
          fastStorage[viewKeyMatch].accountCloseDate = null;
        }
      }else if (!selectedElement.isAccountClosed && hasOpened) {
        const editModelKey = `editOeHbl${selectedElement.hblId}-/oceanExport/hbl/edit`;
        const viewModelKey = `viewOeHbl${selectedElement.hblId}-/oceanExport/hbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        const accountCloseDate = await appContext.api.getFieldValueDate({
          id: selectedElement.hblId,
          tableName: 'T_OOHMAIN',
          fieldName: 'F_AcctCloseDate'
        });

        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 1;
          fastStorage[keyMatch].isAccountClosed = true;
          fastStorage[keyMatch].accountClosedBy = userID;
          fastStorage[keyMatch].accountCloseDate = accountCloseDate;
        }if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 1;
          fastStorage[viewKeyMatch].isAccountClosed = true;
          fastStorage[viewKeyMatch].accountClosedBy = userID;
          fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
        }
      }
    }
    else {
      const hasOpened =
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/edit/${selectedElement.id}`) ||
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/view/${selectedElement.id}`)


      if (selectedElement.isAccountClosed && hasOpened) {
        const editModelKey = `editOeMbl${selectedElement.id}-/oceanExport/mbl/edit`;
        const viewModelKey = `viewOeMbl${selectedElement.id}-/oceanExport/mbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 0;
          fastStorage[keyMatch].isAccountClosed = false;
          fastStorage[keyMatch].accountClosedBy = '';
          fastStorage[keyMatch].accountCloseDate = null;
          if (fastStorage[keyMatch].hblList) {
            fastStorage[keyMatch].hblList.forEach((hbl: OeHbl) => {
              hbl.accountClosed = 0;
            });
          }
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 0;
          fastStorage[viewKeyMatch].isAccountClosed = false;
          fastStorage[viewKeyMatch].accountClosedBy = '';
          fastStorage[viewKeyMatch].accountCloseDate = null;
          if (fastStorage[viewKeyMatch].hblList) {
            fastStorage[viewKeyMatch].hblList.forEach((hbl: OeHbl) => {
              hbl.accountClosed = 0;
            });
          }
        }
      }else if (!selectedElement.isAccountClosed && hasOpened) {
        const editModelKey = `editOeMbl${selectedElement.id}-/oceanExport/mbl/edit`;
        const viewModelKey = `viewOeMbl${selectedElement.id}-/oceanExport/mbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
        const accountCloseDate = await appContext.api.getFieldValueDate({
          id: selectedElement.id,
          tableName: 'T_OOMMAIN',
          fieldName: 'F_AcctCloseDate'
        });


        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 1;
          fastStorage[keyMatch].isAccountClosed = true;
          fastStorage[keyMatch].accountClosedBy = userID;
          fastStorage[keyMatch].accountCloseDate = accountCloseDate;
          if (fastStorage[keyMatch].hblList) {
            fastStorage[keyMatch].hblList.forEach((hbl: OeHbl) => {
              hbl.accountClosed = 1;
            });
          }
          
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 1;
          fastStorage[viewKeyMatch].isAccountClosed = true;
          fastStorage[viewKeyMatch].accountClosedBy = userID;
          fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
          if (fastStorage[viewKeyMatch].hblList) {
            fastStorage[viewKeyMatch].hblList.forEach((hbl: OeHbl) => {
              hbl.accountClosed = 1;
            });
          }
        }
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  let isTracking = (selectedElement?.trStatus && selectedElement?.trStatus !== 'C' && selectedElement?.trStatus !== 'failed' && selectedElement?.trStatus !== 'Q') ?? false;
  // const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  
  const hblSec = findSecurityTask(appContext, FmsSecTask.OEHbl);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: (selectedElement?.hblCount === 'SBL' ? !listSec_H?.grantAdd : !listSec?.grantAdd) },
    { label: 'View', shortcut: 'F9', separator: (selectedElement?.hblCount === 'SBL' ? !listSec_H?.grantEdit : !listSec?.grantEdit) && (selectedElement?.hblCount === 'SBL' ? (!listSec?.grantDel || !listSec_H?.grantDel) : !listSec?.grantDel) },
    { label: 'Edit', shortcut: 'F3', separator: (selectedElement?.hblCount === 'SBL' ? (!listSec?.grantDel || !listSec_H?.grantDel) : !listSec?.grantDel), hidden: (selectedElement?.hblCount === 'SBL' ? !listSec_H?.grantEdit : !listSec?.grantEdit) },
    { label: 'Delete', shortcut: '', separator: false, hidden: (selectedElement?.hblCount === 'SBL' ? (!listSec?.grantDel || !listSec_H?.grantDel) : !listSec?.grantDel) },
    { label: 'New HBL', shortcut: '', separator: true, disabled : (selectedElement?.hblCount === 'DBL' || selectedElement?.hblCount === 'SBL'), hidden: !listSec_H2?.grantAdd},
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to HBL List', shortcut: 'F6', separator: false, disabled : selectedElement?.hblCount === 'DBL', hidden: !hblSec?.grantRead},
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow && noProfitShow, hidden: !listSec?.grantAdd, disabled : selectedElement?.hblCount === 'SBL' },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: noProfitShow},
    { label: 'Container Status Update', shortcut: '', separator: false },
    { label: isTracking ? 'Request Email Notification' : 'Request Tracking Service', shortcut: '', separator: false, hidden: !listSec?.grantEdit },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize || !listSec?.grantEdit },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="oem-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));
  
  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteMbl();
        break;
      case 4:
        createHbl();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        switchToHbl();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
        break;
      case 8:
        copy();
        break;
      case 9:
        viewBillings();
        break;
      case 10:
        viewProfit();
        break;
      case 11:
        openContainerStatus();
        break;
      case 12:
        trackRequestFunc();
        break;
      case 13:
        processFileLock();
        break;
      case 14:
        processAccountLock();
        break;
      case 15:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function MblListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const selectedElement = jobListContext.selectedElement as OeMblListItem;

  const {deleteMbl, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport, trackRequestFunc} = useSelectedMblOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const setSavedEntityAfterRecog = useSetEditedId([JobNames.OEHbl, JobNames.SlipJournal]);
  const {switchJournal} = useJournal();


  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/view/${id}`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAfterRecog('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OEMbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }


  function switchJournalSBL(){
    return selectedElement.hblCount === 'SBL' ? switchJournal(JobNames.OEHbl, selectedElement.hblId, "", null, selectedElement.hblNo) :  switchJournal(JobNames.OEMbl, selectedElement.id, "", null, selectedElement.refNo)
  }

  const allowedStatuses = ['', 'E', 'D'];
  
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEMbl, selectedElement?.branch);
  const listSec_H = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId.startsWith('@');

  const hasSelectedRow = !!selectedElement;
  // const canBeDeleted = hasSelectedRow && !hasOpenedViewOrEditFor(selectedElement.id) && selectedElement.canBeDeleted
  const canBeDeleted = hasSelectedRow && (selectedElement?.hblCount === 'SBL' ? (listSec?.grantDel && listSec_H?.grantDel) : listSec?.grantDel);
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd && selectedElement.hblCount !== 'SBL';
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && (selectedElement?.hblCount === 'SBL' ? listSec_H?.grantEdit : listSec?.grantEdit);

  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false); 


  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='oem-list-add-button' display="primary" link="/oceanExport/mbl/add" disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus} />} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='oem-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='oem-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='oem-list-delete-button' disabled={!canBeDeleted} onClick={deleteMbl} useText/>
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <PrimaryButton name='oem-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        {!noBillingsShow && <BillingsIconButton name='oem-list-billings-button' data-tooltip={constants.List_Billings} onClick={viewBillings} useText/>}
        {!noProfitShow && <PrimaryButton name='oem-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
        <DeleteHistoryIconButton name='oem-list-deleteHistory-button' onClick={moveToDeleteHistoryReport} useText/>
        <RecogHistoryIconButton name='oem-list-recogHistory-button' onClick={moveToRecogHistoryReport} useText/>
        {!checkSecJournal && <JournalIconButton onClick={() => switchJournalSBL()} useText/>}
      </div>
      {jobListContext.trackingRequestModalState && (
        <IfmsModal
          isBlueHeader
          cancelOnEsc
          onCancel={() => {
            const id = jobListContext.trackingRequestModalState?.jobId;
            if (id != null) fastStorage[`oem-trackrequest-${id}`] = null;
            jobListContext.setTrackingRequestModalState(undefined);
          }}
          draggable
          isOpen
          title={getTrackRequestTitle(jobListContext.trackingRequestModalState.trStatus)}
          width="500px"
        >
          <TrackingRequest
            jobId={jobListContext.trackingRequestModalState.jobId}
            storageKey={`oem-trackrequest-${jobListContext.trackingRequestModalState.jobId}`}
            onClose={() => {
              const id = jobListContext.trackingRequestModalState?.jobId;
              if (id != null) fastStorage[`oem-trackrequest-${id}`] = null;
              jobListContext.setTrackingRequestModalState(undefined);
            }}
            jobName={JobNames.OEMbl}
            trStatus={jobListContext.trackingRequestModalState.trStatus}
            trType={jobListContext.trackingRequestModalState.trType}
            mode={jobListContext.trackingRequestModalState.mode}
            vcResult={jobListContext.trackingRequestModalState.vcResult}
            prefetchedGroupData={jobListContext.trackingRequestModalState.prefetchedGroupData}
          />
        </IfmsModal>
      )}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal noVerticalScroll isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_OOMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function MblListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function MblListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as any;
  const history = useHistory();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEMbl, selectedElement?.branch);
  const listSec_H = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement?.branch);

  const {copy, create, edit, view, switchToHbl, viewBillings, viewProfit} = useSelectedMblOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);  
  const hblSec = findSecurityTask(appContext, FmsSecTask.OEHbl);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6' && hblSec.grantRead) {
      switchToHbl();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if (selectedElement?.hblCount === 'SBL') {
        if(listSec_H?.grantEdit)
          edit();
      }
      else {
        if(listSec?.grantEdit)
          edit();
      }
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "CTRL+F2") {
      if (selectedElement?.hblCount !== 'SBL')
        copy();
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      if (selectedElement?.hblCount === 'SBL') {
        if (noProfitShow)
          viewProfit();
      }
      else {
        if (noProfitShow)
          viewProfit();
      }
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `MBL #: ${(jobListContext.selectedElement as OeMblListItem|null)?.mblNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportMbl}
      jobName={JobNames.OEMbl}
      //entityId={(jobListContext.selectedElement as OeMblListItem | null)?.id}
      jobId={(jobListContext.selectedElement as OeMblListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
      isSingleBl={(jobListContext.selectedElement as OeMblListItem|null)?.hblCount === 'SBL'}
      parentJobName={JobNames.OEHbl}
      parentJobId={(jobListContext.selectedElement as OeMblListItem | null)?.hblId ?? 0}
    />
  );
}

function AfterMemoLogButtonCommands() {
  const jobListContext = useContext(JobListViewContext);
  const { trackRequestFunc } = useSelectedMblOperations();
  const selectedElement = jobListContext.selectedElement as OeMblListItem;
  const appContext = useContext(ApplicationContext);
  const hasSelectedRow = !!selectedElement;
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEMbl, selectedElement?.branch);
  const listSec_H = findSecurityTaskWithBranch(appContext, FmsSecTask.OEHbl, selectedElement?.branch); // MBL이 SBL일 때의 HBL 권한
  
  const canBeEdit = hasSelectedRow && (selectedElement?.hblCount === 'SBL' ? listSec_H?.grantEdit : listSec?.grantEdit);

  return (<IconButton style={{ alignItems: 'center', justifyContent: 'center' }} iconHeight="24" name='oem-list-trackingRq-button' disabled={!canBeEdit} onClick={trackRequestFunc} icon={appContext.useDarkMode ? TrackingRQIcon3_D : TrackingRQIcon3} data-tooltip={'CNTR Tracking RQ'}/>);
}

/**
 * Concrete implementation for MBL List screen
 *
 * @class MblListView
 * @extends {AbstractListView}
 */
class MblListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.OEMbl,
      'OeMblListItem',
      OeMblListItem.calculateSearchParameters(search, OeMblListItem.MapOeSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat', 'lclFcl', 'moveType']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: OeMblListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.OEMbl, 'OeMblListItem',
      OeMblListItem.calculateSearchParameters(search, OeMblListItem.MapOeSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat', 'lclFcl', 'moveType']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  OeMblListItem.formatData(apiResult.entities);
  }


  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      /*{
        accessor: 'ebl',
        renderer: CheckboxFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v ? 'true' : 'false',
      },
      {
        accessor: 'expressRelease',
        renderer: CheckboxFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v ? 'true' : 'false',
      },*/
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'lclFcl',
        renderer: LclFclFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'coload',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v === true ? '1' : '0',
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'trStatus',
        renderer: RQFilterEventRenderer,
        searchValueExtractor: (v:any|null|undefined) => v !== null ? changeRQEvent(v): "",
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanExportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean): ListRowRenderer[] {
    return [
      {accessor: 'status', Cell: IndicatorRenderer},
      {accessor: 'shipmentType', Cell: ShipmentTypeRenderer},
      //{accessor: 'recognized', Cell: RecognizedRenderer},
      {accessor: 'confirmDate', Cell: DateRenderer},
      {accessor: 'invStat', Cell: BillingsRenderer},
      {accessor: 'billStat', Cell: BillingsRenderer},
      {accessor: 'crDbStat', Cell: BillingsRenderer},
      {accessor: 'refNo', Cell: RefNoRenderer},
      {accessor: 'memoCnt', Cell: MemoDetailRenderer},
      {accessor: 'coload', Cell: NullableCheckboxIconRenderer},
      {accessor: 'lclFcl', Cell: LclFclRenderer},
      {accessor: 'refNo', Cell: TextAlignLeftRenderer},
      {accessor: 'mblNo', Cell: TextAlignLeftRenderer},
      {accessor: 'hblCount', Cell: HblRenderer, Header: () => <span><u>HBL</u>(s)</span>},
      {accessor: 'branch', Cell: TextRenderer},
      {accessor: 'moveType', Cell: TextAlignLeftRenderer},
      {accessor: 'agentSName', Cell: AgentRenderer},
      {accessor: 'agentRefNo', Cell: TextAlignLeftRenderer},
      {accessor: 'carrierSName', Cell: TextAlignLeftRenderer},
      {accessor: 'bookingNo', Cell: TextAlignLeftRenderer},
      {accessor: 'pLofRec', Cell: TextAlignLeftRenderer},
      {accessor: 'finalDest', Cell: TextAlignLeftRenderer},
      {accessor: 'bookCfrm', Cell: DateRenderer},
      {accessor: 'sedSent', Cell: DateRenderer},
      {accessor: 'dlvrToCarr', Cell: DateRenderer},
      // Don't know yet
      {accessor: 'cargoRelease', Cell: DateRenderer},

      {accessor: 'vessel', Cell: TextAlignLeftRenderer},
      {accessor: 'voyage', Cell: TextAlignLeftRenderer},
      {accessor: 'cutOffDate', Cell: DateRenderer},
      {accessor: 'loadingPort', Cell: TextAlignLeftRenderer},
      {accessor: 'etd', Cell: DateRenderer},
      {accessor: 'disCharge', Cell: TextAlignLeftRenderer},
      {accessor: 'eta', Cell: DateRenderer},
      // {accessor: 'deliveryPort', Cell: TextAlignLeftRenderer},
      // {accessor: 'feta', Cell: DateRenderer},
      {accessor: 'paidStatus', Cell: PaidRenderer},
      {accessor: 'paidDate', Cell: DateRenderer},
      {accessor: 'containerNo', Cell: ContainerRenderer},
      {accessor: 'conType', Cell: TextRenderer},
      {accessor: 'lotNo', Cell: TextAlignLeftRenderer},
      {accessor: 'svccNo', Cell: TextAlignLeftRenderer},
      {accessor: 'createdAt', Cell: DateTimeRenderer},
      {accessor: 'u2Date', Cell: DateTimeRenderer},
      {accessor: 'u2ID', Cell: TextAlignLeftRenderer},
      {accessor: 'u1ID', Cell: TextAlignLeftRenderer},
      {accessor: 'trStatus', Cell: (props: any) => <LastEventRenderer {...props} jobName={JobNames.OEMbl} />, 
              Header: () =>  <div style={{gap:'4px', display:'flex'}}><img src={useDarkMode ? cntrGreen: cntrBlue} alt='' /><div>Container Tracking</div></div>},
      {accessor: 'trDate', Cell: DateTimeRenderer}
    ];
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
    colRenderer.push({ accessor: 'lclFcl', changedValue: (value: any) => { return formatLclFcl(value['lclFcl']) } });
    colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { return displayLastTrackingEvent(value)}});
    
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getTableSettings(opType: string, systemSettings: SystemSettings, suntekSettings: SuntekSettings): TableSettings {
    const tsettings = oceanExportMblList;
    const lType = this.suntekSettings?.oceanAir?.useLotNumber ? OemListType.UseLot : OemListType.Normal;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = OeMblListItem.getExportCollection(lType, useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <MblListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <MblListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <MblListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: OeMblListItem) {
    if (row.hblCount === 'SBL' && row.hblId > 0) 
      return row && row.hblId ? `/oceanExport/hbl/view/${row.hblId}` : '';
    else 
      return row && row.id ? `/oceanExport/mbl/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'MBL List';
  };

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
    if (!rowId) {
      return null;
    }

    const selectedElement = context.selectedElement as OeMblListItem;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OEMbl, selectedElement?.branch);

    function onClose() {
      const storageKey = `oe-mbl-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="Container Status Update" width="760px">
        <MblMilestonePopup mblId={rowId} storageKey={`oe-mbl-milestone-${rowId}`} onClose={onClose} isView={!listSec?.grantEdit} />
      </IfmsModal>
    );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.OEMbl} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  useLogHistory(): boolean {
    return true;
  }
}

export default MblListView;
